import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const NotificationsPanel = () => {
  // Sample notifications data - in a real app, this would come from API
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'tournament',
      title: 'Tournament Starting Soon',
      message: 'Your PUBG Mobile Championship tournament starts in 2 hours. Get ready!',
      time: '2 hours ago',
      isRead: false,
      link: '/player/tournaments/1',
    },
    {
      id: 2,
      type: 'team',
      title: 'Team Invitation',
      message: 'You have been invited to join "Phoenix Squad" team',
      time: '1 day ago',
      isRead: false,
      link: '/player/teams',
    },
    {
      id: 3,
      type: 'wallet',
      title: 'Prize Money Received',
      message: 'You received ₹1,500 tournament prize money in your wallet',
      time: '3 days ago',
      isRead: true,
      link: '/player/wallet',
    },
    {
      id: 4,
      type: 'system',
      title: 'Account Verified',
      message: 'Your account has been successfully verified. You now have full access to all features.',
      time: '1 week ago',
      isRead: true,
      link: '/player/profile',
    },
    {
      id: 5,
      type: 'tournament',
      title: 'Registration Successful',
      message: 'You have successfully registered for Free Fire Solo Challenge',
      time: '1 week ago',
      isRead: true,
      link: '/player/tournaments/2',
    }
  ]);
  
  // Filter state for showing read/unread/all notifications
  const [filter, setFilter] = useState('all');
  
  // Mark a notification as read
  const markAsRead = (id) => {
    setNotifications(notifications.map(notification => 
      notification.id === id ? {...notification, isRead: true} : notification
    ));
  };
  
  // Mark all notifications as read
  const markAllAsRead = () => {
    setNotifications(notifications.map(notification => ({...notification, isRead: true})));
  };
  
  // Get notification icon based on type
  const getNotificationIcon = (type) => {
    switch(type) {
      case 'tournament':
        return (
          <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 flex-shrink-0">
            <span className="material-symbols-outlined">emoji_events</span>
          </div>
        );
      case 'team':
        return (
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 flex-shrink-0">
            <span className="material-symbols-outlined">groups</span>
          </div>
        );
      case 'wallet':
        return (
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600 flex-shrink-0">
            <span className="material-symbols-outlined">payments</span>
          </div>
        );
      case 'system':
        return (
          <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 flex-shrink-0">
            <span className="material-symbols-outlined">info</span>
          </div>
        );
      default:
        return (
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 flex-shrink-0">
            <span className="material-symbols-outlined">notifications</span>
          </div>
        );
    }
  };
  
  // Filter notifications based on selected filter
  const filteredNotifications = notifications.filter(notification => {
    if (filter === 'unread') return !notification.isRead;
    if (filter === 'read') return notification.isRead;
    return true; // 'all' filter
  });
  
  // Count unread notifications
  const unreadCount = notifications.filter(notification => !notification.isRead).length;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold text-gray-800">Notifications</h2>
        {unreadCount > 0 && (
          <button 
            onClick={markAllAsRead}
            className="text-sm text-primary-600 hover:text-primary-800 flex items-center"
          >
            <span className="material-symbols-outlined text-sm mr-1">done_all</span>
            Mark all as read
          </button>
        )}
      </div>
      
      {/* Filter tabs */}
      <div className="flex border-b">
        <button 
          onClick={() => setFilter('all')}
          className={`py-2 px-4 text-sm font-medium ${filter === 'all' ? 'text-primary-600 border-b-2 border-primary-600' : 'text-gray-500 hover:text-gray-700'}`}
        >
          All
        </button>
        <button 
          onClick={() => setFilter('unread')}
          className={`py-2 px-4 text-sm font-medium ${filter === 'unread' ? 'text-primary-600 border-b-2 border-primary-600' : 'text-gray-500 hover:text-gray-700'}`}
        >
          Unread {unreadCount > 0 && `(${unreadCount})`}
        </button>
        <button 
          onClick={() => setFilter('read')}
          className={`py-2 px-4 text-sm font-medium ${filter === 'read' ? 'text-primary-600 border-b-2 border-primary-600' : 'text-gray-500 hover:text-gray-700'}`}
        >
          Read
        </button>
      </div>
      
      {/* Notifications list */}
      <div className="space-y-4">
        {filteredNotifications.length > 0 ? (
          filteredNotifications.map(notification => (
            <div 
              key={notification.id} 
              className={`bg-white rounded-lg shadow p-4 ${!notification.isRead ? 'border-l-4 border-primary-500' : ''}`}
              onClick={() => markAsRead(notification.id)}
            >
              <div className="flex items-start">
                {getNotificationIcon(notification.type)}
                <div className="ml-4 flex-1">
                  <div className="flex justify-between">
                    <h3 className={`font-medium ${!notification.isRead ? 'text-gray-900' : 'text-gray-700'}`}>
                      {notification.title}
                    </h3>
                    <span className="text-xs text-gray-500">{notification.time}</span>
                  </div>
                  <p className={`text-sm mt-1 ${!notification.isRead ? 'text-gray-800' : 'text-gray-600'}`}>
                    {notification.message}
                  </p>
                  <div className="mt-2">
                    <Link 
                      to={notification.link} 
                      className="text-sm text-primary-600 hover:text-primary-800"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8 bg-white rounded-lg shadow">
            <div className="text-gray-400 text-5xl mb-3">
              <span className="material-symbols-outlined" style={{ fontSize: '3rem' }}>notifications_off</span>
            </div>
            <h3 className="text-lg font-medium text-gray-700">No notifications</h3>
            <p className="text-gray-500 mt-1">
              {filter === 'all' 
                ? "You don't have any notifications yet" 
                : filter === 'unread' 
                  ? "You don't have any unread notifications" 
                  : "You don't have any read notifications"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationsPanel;
